module.exports = __webpack_public_path__ + "img/Assembly.eb3a1f2b.png";